import React from "react";
import styled from "styled-components";

const ComingSoon = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #666;
  font-style: italic;
`;

export default function TranslateHistory() {
  return (
    <ComingSoon>
      Translation history coming soon...
    </ComingSoon>
  );
}
